import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import AboutUsContent from "../ones/AboutUsContent";
import CallToAction from "../ones/CallToAction";

export default function AboutUsLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <AboutUsContent />
        <CallToAction />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
